<template>
  <CosFixFooterPage>
  <div class="menu-box">
    <div class="title">管理详情</div>
    <a-spin :spinning="spinning">
      <div class="detail-box">
        <a-form :model="formState" ref="formDetail" name="basic" :wrapper-col="{ span: 22 }" autocomplete="off">
        <a-form-item label="上级名称" name="topName" >
            <a-input v-model:value="formState.topName" :maxlength="100" :disabled="true" />
          </a-form-item>
          <a-form-item label="名称" name="areaName" :rules="[{ required: true, message: '不可为空！' }]">
            <a-input v-model:value="formState.areaName" :maxlength="100" placeholder="请输入" :disabled="!showEditDetail" v-trim/>
          </a-form-item>
          <a-form-item label="顺序" name="sort" :rules="[{ required: true, message: '不可为空！' }]">
            <a-input-number v-model:value="formState.sort" :min="0" placeholder="请输入" :disabled="!showEditDetail"/>
          </a-form-item>
        </a-form>
      </div>
    </a-spin>
    </div>
    <template #footer>
      <a-button type="primary" html-type="submit" @click="handleSubmit" :disabled="!showEditDetail">保存</a-button>
    </template>

    </CosFixFooterPage>
</template>

<script lang="ts">
import { defineComponent, ref, toRefs, watch, PropType } from 'vue'
import { getIdServiceParam, saveServiceParam, updateServiceParam } from '@/api/yuntuSales/customerArea'
import type { yuntuCustomerAreaSaveParams } from '@/typings/api/systemSetting'
import { TreeDetail } from '../hooks/enum'
import type { SystemSetting } from '@/types/systemSetting'
import { DcMessage } from '@dc-platform/dc-components'
import CosFixFooterPage from '@/components/CosFullLayout/fixFooterPage.vue'

export default defineComponent({
  props: {
    data: {
      type: String,
      default: '0'
    },
    addData: {
      type: Object as PropType<SystemSetting.AddDataType>
    },
    showEdit: {
      type: Boolean,
      default: false
    }
  },
  components: { CosFixFooterPage },
  setup(props, { emit }) {
    const formDetail: any = ref(null)
    const formState = ref<yuntuCustomerAreaSaveParams>({
      areaName: '',
      sort: '',
      topName: '-'
    })
    const spinning = ref<boolean>(false)
    const detailId = ref<string>()
    const addData = ref()
    const selectData = toRefs(props).data
    const submitType = ref('add')
    const showEditDetail = ref(false)

    watch(props, () => {
      detailId.value = props.data
      if (props.data === TreeDetail.EMPTY) {
        submitType.value = 'add'
        formDetail.value?.resetFields()
      } else if (props.data === TreeDetail.ADDNEW) {
        submitType.value = 'add'
        addData.value = props.addData
        formDetail.value?.resetFields()
      } else if (props.data === TreeDetail.ZERO) {
        return
      } else {
        submitType.value = 'edit'
        getDetail(props.data)
      }
      formState.value.topName = props.addData?.name ? props.addData?.name : '-'
      showEditDetail.value = props.showEdit
    })
    const fromStringToArr = (str:string) => {
      const arr = str.split('/')
      if (arr.length > 1) {
        return arr[arr.length - 2]
      } else {
        return '-'
      }
    }
    const getDetail = async (id: string) => {
      try {
        spinning.value = true
        const res: any = await getIdServiceParam({
          areaId: id
        })
        formState.value = res.data
          ? {
              areaName: res.data.areaName,
              sort: res.data.sort,
              topName: fromStringToArr(res.data.fullName)
            }
          : {
              areaName: '',
              sort: '',
              topName: ''
            }
        spinning.value = false
      } catch (error) {
        spinning.value = false
        console.log('getDetailerror: ', error)
      }
    }
    const handleSubmit = () => {
      try {
        formDetail.value.validate().then(async () => {
          // if (!addData.value) {
          //   DcMessage.error('请先进入编辑模式，选择需要新增或编辑的数据！')
          //   return
          // }
          if (submitType.value === 'add') {
            await saveServiceParam({
              parentId: addData.value.id,
              appId: addData.value.appId,
              ...formState.value
            })
            DcMessage.success('新增成功')
            formDetail.value?.resetFields()
            emit('successRefresh')
          }
          if (submitType.value === 'edit') {
            await updateServiceParam({
              areaId: detailId.value,
              ...formState.value
            })
            emit('successRefresh')
            DcMessage.success('更新成功')
          }
        })
      } catch (error) {
        console.log('handleSubmit error: ', error)
      }
    }
    return {
      selectData,
      formState,
      spinning,
      formDetail,
      handleSubmit,
      showEditDetail
    }
  }
})
</script>
<style lang="scss" scoped>
:deep(.ant-switch-checked .ant-switch-handle) {
  left: 65%;
}
.menu-box {
  padding: 16px 16px 0;
  .detail-box {
    box-sizing: border-box;
    padding: 30px 250px;
  }
  .title {
    font-weight: 500;
    font-size: 16px;
    color: #132043;
    padding-left: 8px;
    position: relative;
    margin-bottom: 12px;
  }
  .title::after {
    width: 2px;
    height: 20px;
    background-color: #1d4cd2;
    position: absolute;
    left: 0;
    top: 3px;
    content: '';
  }
  .input {
    width: 80px;
    display: inline-block;
    margin: 0 5px;
  }
  .subTitle {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    height: 40px;
    display: flex;
    align-items: center;
    margin: 25px 20px 16px;
    border-bottom: 1px solid rgb(235, 239, 241);
  }
  p {
    padding-left: 20px;
    margin-bottom: 10px;
  }
  .footer-box {
    width: 100%;
    height: 64px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .line-bg {
    width: 100%;
    height: 8px;
    background-color: rgb(249, 249, 255);
    padding: 0 16px;
    box-sizing: content-box;
    left: -16px;
    position: absolute;
    bottom: 64px;
  }
}
</style>
